var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { HttpBooksApiV5Request } from "./http-api-request.js";
export function createFile(bookId, file, config) {
    return __awaiter(this, void 0, void 0, function* () {
        var response = yield new HttpBooksApiV5Request(`${bookId}/files`, config).setMethod('POST').setPayload(file).fetch();
        return response.data;
    });
}
export function getFile(bookId, id, config) {
    return __awaiter(this, void 0, void 0, function* () {
        var response = yield new HttpBooksApiV5Request(`${bookId}/files/${id}`, config).setMethod('GET').fetch();
        return response.data;
    });
}
export function listFiles(bookId, limit, cursor, config) {
    return __awaiter(this, void 0, void 0, function* () {
        if (!limit) {
            limit = 100;
        }
        const request = new HttpBooksApiV5Request(`${bookId}/files`, config);
        request.addParam('limit', limit);
        if (cursor != null) {
            request.setHeader('cursor', cursor);
        }
        const response = yield request.fetch();
        return response.data;
    });
}
export function updateFile(bookId, file, config) {
    return __awaiter(this, void 0, void 0, function* () {
        let response = yield new HttpBooksApiV5Request(`${bookId}/files`, config).setMethod('PUT').setPayload(file).fetch();
        return response.data;
    });
}
export function deleteFile(bookId, file, config) {
    return __awaiter(this, void 0, void 0, function* () {
        const response = yield new HttpBooksApiV5Request(`${bookId}/files/${file.id}`, config).setMethod('DELETE').fetch();
        return response.data;
    });
}
//# sourceMappingURL=file-service.js.map